import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiHelper } from '@helpers/ui.helper';
import { Router } from '@angular/router';

export interface DialogData {
  barcode: string;
  type: string;
}

@Component({
  selector: 'verification-dialog',
  templateUrl: '../sharedTemplates/verification.dialog.component.html',
})
export class VerificationDialog {
  constructor(
    public dialogRef: MatDialogRef<VerificationDialog>,
    private _router: Router,

    private _UiHelper: UiHelper
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
